"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = assetHasError;

function assetHasError(a) {
  if (!a || !a.assetFiles) return !1;
  var b = a.assetFiles.ORIGINAL;
  return b && "ERROR" === b.status;
}